import Cookies from "js-cookie";
import { fetchCartSafeMoqs } from "./../store/actions/MoqActions";
import { toast } from "react-toastify";


const truncateText = (str, length) => {
  if (length == null) {
    length = 100;
  }

  const ending = "...";

  if (str.length > length) {
    return str.substring(0, length - ending.length) + ending;
  } else {
    return str;
  }
};

const toTitleCase = (toTransform) => {
  toTransform = toTransform.toLowerCase();
  return toTransform.replace(/\b([a-z])/g, function (_, initial) {
    return initial.toUpperCase();
  });
};

const registerGtagEvent = (eventName) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: eventName,
  });
  // Additional logic for your button click
  return eventName;
};

function findMinMax(arr) {
  let min = 0;

  let max = 0;

  if (arr === undefined) {
    return { min, max };
  } else {
    min = arr && arr?.length > 0 ? arr[0].price : 0;

    max = arr && arr?.length > 0 ? arr[0].price : 0;
  }

  if (arr && arr?.length > 0) {
    for (let i = 1, len = arr.length; i < len; i++) {
      let v = arr[i].price;
      min = v < min ? v : min;
      max = v > max ? v : max;
    }
  }

  return { min, max };
}

function tokenExpired() {
  const exists = fetchTokenExpiry();
  if (!exists) return false;
  const expiry = Cookies.get("ltdn_exp") || null;
  const currentTime = Date.now() / 1000;
  return currentTime > expiry;
}

function fetchTokenExpiry() {
  const token = Cookies.get("ltdn_exp") || null;
  return token;
}

function isAuthenticated() {
  const expiry = fetchTokenExpiry();
  if (!expiry) return false;
  const currentTime = Date.now() / 1000;
  const authenticated = expiry > currentTime;
  return authenticated;
}

function removeTags(str) {
  if (str === null || str === "") return false;
  else str = str.toString();

  // Regular expression to identify HTML tags in
  // the input string. Replacing the identified
  // HTML tag with a null string.
  return str.replace(/(<([^>]+)>)/gi, "");
}

function getCurrentDateTime() {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
  const day = String(now.getDate()).padStart(2, "0");
  const hours = String(now.getHours()).padStart(2, "0");
  const minutes = String(now.getMinutes()).padStart(2, "0");
  const seconds = String(now.getSeconds()).padStart(2, "0");

  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
}


async function getCleanCart(cartData) {
  if (!cartData || cartData.length === 0) {
    return [];
  }

  try {
    const moqIds = cartData.map(item => item.moq_id);
    const cartValidMoqIds = await fetchCartSafeMoqs(moqIds);

    if (Array.isArray(cartValidMoqIds) && cartValidMoqIds.length > 0) {
      const filteredCart = cartData.filter(item =>
        cartValidMoqIds.includes(item.moq_id)
      );
      return filteredCart;
    } else {
      return [];
    }
  } catch (err) {
    return cartData; // fail gracefully
  }
}

async function runCleanCart() {
  const cartData = JSON.parse(localStorage.getItem("bids")) || [];

  const newCart = await getCleanCart(cartData);

  // Save updates back to localStorage
  localStorage.setItem("bids", JSON.stringify(newCart));

  return newCart;
}

function toastWithTitle(title, message) {
  toast(
    <div>
      <strong>{title}</strong>
      <div>{message}</div>
    </div>,
    {
      position: "top-right",
      autoClose: 3000, // 3s
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    }
  );
}

function formatDateWithSuffix(dateString) {
  const date = new Date(dateString);

  const day = date.getDate();
  const month = date.toLocaleString("en-US", { month: "long" });
  const year = date.getFullYear();

  function getSuffix(n) {
    if (n >= 11 && n <= 13) return "th";
    switch (n % 10) {
      case 1: return "st";
      case 2: return "nd";
      case 3: return "rd";
      default: return "th";
    }
  }

  return `${month} ${day}${getSuffix(day)}, ${year}`;
}


export {
  truncateText,
  toTitleCase,
  findMinMax,
  tokenExpired,
  removeTags,
  registerGtagEvent,
  isAuthenticated,
  getCurrentDateTime,
  runCleanCart,
  toastWithTitle,
  formatDateWithSuffix,
};
